import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AppUpdateService {
  constructor(private http: HttpClient) {}

  getVersion(version: string) {
    return this.http
      .head(`:API_BASE_URLapps/versions/${version}`, {
        observe: 'response',
      })
      .pipe(
        map((response) => ({ ok: true, status: response.status })),
        catchError((error: HttpErrorResponse) => {
          return of({ ok: false, status: error.status ?? 426 });
        })
      );
  }
}
